/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Skeleton, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getSegmentDescription } from './segmentConstants';

const SegmentViewDescription = ({ dim, seg, segmentLabel, loading }) => {
  if (loading) {
    return <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />;
  }

  const text = getSegmentDescription(dim, seg, segmentLabel);
  if (!text) return null;

  const parts = text.split(/\*\*(.*?)\*\*/g);

  return (
    <Alert
      severity="info"
      variant="outlined"
      icon={<InfoOutlinedIcon fontSize="small" />}
      sx={{ borderRadius: 2, py: 0.75, alignItems: 'flex-start' }}
    >
      <Typography variant="body2" color="text.secondary" component="span">
        {parts.map((part, index) =>
          index % 2 === 1 ? (
            <Typography
              key={`b-${index}`}
              component="span"
              variant="body2"
              sx={{ fontWeight: 700, color: 'text.primary' }}
            >
              {part}
            </Typography>
          ) : (
            <React.Fragment key={`t-${index}`}>{part}</React.Fragment>
          ),
        )}
      </Typography>
    </Alert>
  );
};

SegmentViewDescription.propTypes = {
  dim: PropTypes.string.isRequired,
  seg: PropTypes.string,
  segmentLabel: PropTypes.string,
  loading: PropTypes.bool,
};

SegmentViewDescription.defaultProps = {
  seg: null,
  segmentLabel: null,
  loading: false,
};

export default SegmentViewDescription;
